/**
 * This file configures and exports an instantiated Firebase
 * SDK instance to the rest of the app. All other parts of the
 * app that needs firebase services should import firebase from
 * here.
 *
 * The firebase SDK must be configured before use. This is what
 * happens in the code block below. See config.ts for the
 * configuration object.
 */

import * as Firebase from 'firebase/app'
import { config } from './config'

Firebase.initializeApp(config)

// Fix to make local development use the firestore emulator
//
if (process.env.environment === 'DEVELOPMENT') {
  Firebase.firestore().settings({
    host: process.env.firestoreEmulatedUrl,
    ssl: false,
  })
}

export default Firebase
